/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react'
import { Row, Col, Input, message, Drawer, Form, DatePicker } from 'antd'

import { Editor } from 'react-draft-wysiwyg'
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css'
import { EditorState, convertToRaw, ContentState } from 'draft-js'
import draftToHtml from 'draftjs-to-html'
import htmlToDraft from 'html-to-draftjs'

import _ from 'lodash'
import { observer, inject } from 'mobx-react'
import { compose } from 'recompose'
import { graphql } from 'react-apollo'
import gql from 'graphql-tag'
import moment from 'moment'

import OfficerSelect from '../../../components/Custom/OfficerSelect'

class Index extends Component {
	constructor(props) {
		super(props)

		this.state = {
			isSaving: false,
			editorState: null,
			present: [],
			absent: []
		}
        
		this.handleSubmit = this.handleSubmit.bind(this)
	}

	componentDidMount() {
		const { selectedResolution } = this.props
		if (selectedResolution) {
			let editorState = null
			const content = selectedResolution.content
			if (content) {
				const contentBlock = htmlToDraft(content)
				if (contentBlock) {
					const contentState = ContentState.createFromBlockArray(contentBlock.contentBlocks)
					editorState = EditorState.createWithContent(contentState)
				}
			}
			const present = JSON.parse(selectedResolution.present)
			const absent = JSON.parse(selectedResolution.absent)
			this.setState({ editorState, present, absent })
		}
	}
    
	handleSubmit(e) {
		e.preventDefault()
		const { present, absent, editorState } = this.state
		const { form, AuthStore, saveResolution, onClose, selectedResolution } = this.props
		const { barangay_uid } = AuthStore
		const { resetFields } = form
		
		form.validateFields((err, values) => {
			if (err) {
				return false
			}
			if (present.length == 0) {
				message.error('No assigned attendees')
				return false
			}

			let content = null
			if (editorState) {
				content = draftToHtml(convertToRaw(editorState.getCurrentContent()))
			}
			const schedule = moment(values.schedule).format('YYYY-MM-DD HH:mm:ss')
			let params = Object.assign({}, values, { 
				barangay_uid, schedule,
				present, absent, content
			})
			if (selectedResolution) {
				params = Object.assign({}, params, { resolution_uid: selectedResolution.uid })
			}
			console.log('params', params)

			message.loading({ key: 'set_resolution', content: 'Saving resolution, please wait..' })
			this.setState({ isSaving: true }, () => {
				saveResolution(params).then((response) => {
					const { file_url } = response.data.setResolution
					window.open(`${process.env.REACT_APP_BACKEND_API}${file_url}`, '_blank')
					this.setState({ isSaving: false })
					message.success({ key: 'set_resolution', content: 'Resolution successfully generated.' })

					//create audit trail
					const auditParams = {
						module_name: 'Resolutions',
						action: (selectedResolution) ? 'Update' : 'Create',
						message: (selectedResolution) ? 
							`Update resolution ${params.title} details` : 
							`Created new resolution ${params.title}`
					}
					AuthStore.saveAuditTrail(auditParams)

					onClose()
				}).catch(err => {
					this.setState({ isSaving: false })
					console.log('error saving resolution')
					message.error({ key: 'set_resolution', content: err.message.replace('GraphQL error:', '') })
					resetFields()
				})
			})
		})
	}

	render() {
		const { editorState, present, absent } = this.state
		const { 
			AuthStore, visible, onClose, form, selectedResolution
		} = this.props
		const { getFieldDecorator } = form
		const { barangay_uid, barangay_term_uid } = AuthStore
		// console.log('present', present)
		// console.log('absent', absent)

		return (
			<Drawer
				title="Resolutions Management"
				placement="right"
				// closable={false}
				onClose={onClose}
				visible={visible}
				width={'70%'}
				bodyStyle={{ maxHeight: '90%', overflow: 'scroll' }}
			>
				<Form onSubmit={this.handleSubmit}>
					<Row gutter={32}>
						<Col md={12} sm={24}>
							<Form.Item label='Title'>
								{ getFieldDecorator('title', {
									initialValue: (selectedResolution) ? selectedResolution.title : null,
									rules: [{
										required: true,
										message: 'This field is required.'
									}, {
										validator: (rule, value, callback) => {
											if (value && ((value.length > 0) && (!value.replace(/\s/g, '').length))) {
												callback('only white space detected.')
											}
											callback()
										}
									}]
								})
								(
									<Input placeholder='Enter Resolution title'/>
								)}
							</Form.Item>
						</Col>
						<Col md={12} sm={24}>
							<Form.Item label='Schedule'>
								{ getFieldDecorator('schedule', {
									initialValue: (selectedResolution) ? 
										moment(new Date(selectedResolution.schedule)) : 
									    moment(new Date()),
									rules: [{
										required: true,
										message: 'This field is required.'
									}]
								})
								(
									<DatePicker 
										showTime
										format='lll'
										style={{ width: '100%' }}
										// disabledDate={this.disabledDate}
									/>
								)}
							</Form.Item>
						</Col>
					</Row>
					<Row gutter={32}>
						<Col md={12} sm={24}>
							<label>Present</label>
							<OfficerSelect 
								barangay_uid={barangay_uid}
								barangay_term_uid={barangay_term_uid}
								onChange={_.noop}
								onSelectedItem={(item) => {
									if (!item) return
									const isSelectedPresent = _.find(present, i => i.uid == item.uid)
									const isSelectedAbsent = _.find(absent, i => i.uid == item.uid)
									if (!isSelectedPresent && !isSelectedAbsent) {
										present.push({
											uid: item.uid,
											full_name: item.full_name,
											position: item.position_name
										})
										this.setState({ present })
									} else if (isSelectedPresent) {
										message.error(`${item.full_name} already marked as present`)
									} else if (isSelectedAbsent) {
										message.error(`${item.full_name} already marked as absent`)
									}
								}}
							/>
							<Row style={{ marginTop: 10 }} gutter={16}>
								<ul>
									{
										present.map((i, key) => (
											<li key={key}>
												<span style={{ marginRight: 5, fontSize: '16px' }}>{i.full_name} ({i.position})</span>
												<a href='javascript:void(0)' style={{ color: 'red' }} onClick={() => {
													present.splice(key, 1)
													this.setState({ present })
												}}>remove</a>
											</li>
										))
									}
								</ul>
							</Row>
						</Col>
						<Col md={12} sm={24}>
							<label>Absent</label>
							<OfficerSelect 
								barangay_uid={barangay_uid}
								barangay_term_uid={barangay_term_uid}
								onChange={_.noop}
								onSelectedItem={(item) => {
									if (!item) return
									const isSelectedPresent = _.find(present, i => i.uid == item.uid)
									const isSelectedAbsent = _.find(absent, i => i.uid == item.uid)
									if (!isSelectedPresent && !isSelectedAbsent) {
										absent.push({
											uid: item.uid,
											full_name: item.full_name,
											position: item.position_name
										})
										this.setState({ absent })
									} else if (isSelectedPresent) {
										message.error(`${item.full_name} already marked as present`)
									} else if (isSelectedAbsent) {
										message.error(`${item.full_name} already marked as absent`)
									}
								}}
							/>
							<Row style={{ marginTop: 10 }} gutter={16}>
								<ul>
									{
										absent.map((i, key) => (
											<li key={key}>
												<span style={{ marginRight: 5, fontSize: '16px' }}>{i.full_name} ({i.position})</span>
												<a href='javascript:void(0)' style={{ color: 'red' }} onClick={() => {
													absent.splice(key, 1)
													this.setState({ absent })
												}}>remove</a>
											</li>
										))
									}
								</ul>
							</Row>
						</Col>
					</Row>
					<Row style={{ marginTop: 5 }}>
						<Form.Item label='Content'>
							{ getFieldDecorator('content', {
								//initialValue: (selectedOfficer) ? selectedOfficer.work_history : null,
								rules: [{
									required: false,
									message: 'This field is required.'
								}, {
									validator: (rule, value, callback) => {
										if (value && ((value.length > 0) && (!value.replace(/\s/g, '').length))) {
											callback('only white space detected.')
										}
										callback()
									}
								}]
							})
							(
								//<Input.TextArea rows={16} placeholder='Enter some work history'/>
								<Editor
								 	editorState={editorState}
									toolbarClassName="toolbarClassName"
									wrapperClassName="wrapperClassName"
									editorClassName="editorClassName"
								 	onEditorStateChange={(state) => this.setState({ editorState: state })}
								/>
							)}
						</Form.Item>
					</Row>
				</Form>
				<div
					style={{
						position: 'absolute',
						right: 0,
						bottom: 10,
						width: '100%',
						borderTop: '1px solid #e9e9e9',
						padding: '10px 16px',
						background: '#fff',
						textAlign: 'center',
					}}
				>
					<button type="button" className="btn btn-block btn-primary btn-rounded waves-effect waves-light" onClick={this.handleSubmit}>Save</button>
				</div>
			</Drawer>
		)
	}
}

const SET_RESOLUTION = gql`
    mutation setResolution($input: JSON) {
		setResolution(input: $input)
    }
`
const DELETE_PROJECT_ATTACHMENT = gql`
    mutation deleteProjectAttachment($input: JSON) {
		deleteProjectAttachment(input: $input)
    }
`

const composed = compose(
	Form.create({ name: 'form-barangay-projects' }),
	inject('AuthStore'),
	graphql(SET_RESOLUTION, {
		props({ mutate }) {
			return {
				saveResolution(params) {
					return mutate({
						variables: { input: params },
					  	refetchQueries: ['allResolutions']
					})
				}
			}
		}
	}),
	graphql(DELETE_PROJECT_ATTACHMENT, {
		props({ mutate }) {
			return {
				deleteAttachment(params) {
					return mutate({
						variables: { input: params },
					  	refetchQueries: ['allResolutions']
					})
				}
			}
		}
	}),
	observer
)

export default composed(Index)
